import { ProfileForm } from '../profile/components/forms/profile-form/profile.form';
import { Steps } from './register.types';
import BankFormStep from './steps/bank-form/bank-form.step';
import { DocumentsFormStep } from './steps/documents-form/documents-form.step';
import WaitingStep from './steps/waiting.page';
import RegisterTicketStep from './steps/ticket/register-ticket.step';

export const registerSteps: Steps = {
    profile: {
        name: 'profile',
        label: 'تکمیل پروفایل',
        description: 'اطلاعات اصلی حساب را تکمیل کنید',
        icon: <i className="fa-light fa-address-card"></i>,
        component: <ProfileForm />,
        disable_back: true,
    },
    bank: {
        label: 'اطلاعات بانکی',
        description: 'شماره شبای اصلی و پشتیبان را ثبت کنید',
        icon: <i className="fa-light fa-building-columns"></i>,
        component: <BankFormStep />,
    },
    documents: {
        label: 'ارسال مدارک',
        description: 'مدارک احراز هویت را بارگذاری کنید',
        icon: <i className="fa-light fa-folder-open"></i>,
        component: <DocumentsFormStep />,
    },
    waiting: {
        label: 'وضعیت مدارک',
        description: 'در انتظار بررسی',
        icon: <i className="fa-light fa-shield-check"></i>,
        component: <WaitingStep />,
        disable_back: true,
    },
    ticket: {
        name: 'ticket',
        label: 'ارتباط با پشتیبانی',
        description: 'گفتگو با پشتیبانی بدون خروج از فرایند ثبت‌نام',
        icon: <i className="fa-light fa-headset"></i>,
        component: <RegisterTicketStep />,
    },
    'ticket/:ticketId': {
        name: 'ticket',
        label: 'ارتباط با پشتیبانی',
        description: 'گفتگو با پشتیبانی بدون خروج از فرایند ثبت‌نام',
        icon: <i className="fa-light fa-headset"></i>,
        component: <RegisterTicketStep />,
    },
};
